import React, { useEffect } from "react";
import Button from "../../common/components/Button";
import { useNavigate } from "react-router-dom";
import { completeInterview } from "../../auth/services/authService";
import Header from "../layout/Header";
const Results = () => {
  const navigate = useNavigate();

  useEffect(() => {
    completeInterview();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header showLandingNav={false} />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-4">Results</h1>
        <h2 className="text-xl font-medium mb-4">
          You have completed the interview.
        </h2>
      </div>
      <Button text="Back to Landing Page" onClick={() => navigate("/")} />
    </div>
  );
};

export default Results;
